import styled from "styled-components";

export const Red = styled.span`
font-size: small;
color: red;
`